import { useLanguage } from "../../lib/i18n";

export const LanguageToggle = ({ className = "" }) => {
    const { lang, setLang } = useLanguage();
    return (
        <div
            data-testid="language-toggle"
            className={`inline-flex items-center bg-white border border-rvs-navy-10 rounded-full p-0.5 text-xs font-bold ${className}`}
        >
            <button
                data-testid="lang-toggle-en"
                onClick={() => setLang("en")}
                aria-pressed={lang === "en"}
                className={`px-3 py-1.5 rounded-full transition-colors ${
                    lang === "en" ? "bg-rvs-navy text-white" : "text-rvs-navy/70 hover:text-rvs-navy"
                }`}
            >
                EN
            </button>
            <button
                data-testid="lang-toggle-te"
                onClick={() => setLang("te")}
                aria-pressed={lang === "te"}
                className={`px-3 py-1.5 rounded-full transition-colors ${
                    lang === "te" ? "bg-rvs-navy text-white" : "text-rvs-navy/70 hover:text-rvs-navy"
                }`}
                style={{ fontFamily: "'Noto Sans Telugu', 'Manrope', sans-serif" }}
            >
                తెలుగు
            </button>
        </div>
    );
};
